import { useEffect, useRef, useState } from "react";

export default function InSpektLoader({ progress = null, step = "Initializing InSpekt…" }) {
  const isDeterminate = typeof progress === "number";

  const [fill, setFill] = useState(0);
  const fillRef = useRef(0);
  const rafRef  = useRef(null);

  useEffect(() => {
    if (!isDeterminate) return;
    const target = progress;
    const animate = () => {
      const remaining = target - fillRef.current;
      if (remaining <= 0.15) { fillRef.current = target; setFill(target); return; }
      fillRef.current += remaining * 0.08;
      setFill(fillRef.current);
      rafRef.current = requestAnimationFrame(animate);
    };
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(animate);
    return () => { if (rafRef.current) cancelAnimationFrame(rafRef.current); };
  }, [progress, isDeterminate]);

  return (
    <div style={{
      position:       "fixed",
      inset:          0,
      display:        "flex",
      flexDirection:  "column",
      alignItems:     "center",
      justifyContent: "center",
      background:     "#ffffff",
      zIndex:         9999,
      gap:            24,
      fontFamily:     "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      WebkitFontSmoothing: "antialiased",
    }}>

      {/* Spinner */}
      <div style={{
        width:        48,
        height:       48,
        borderRadius: "50%",
        border:       "3px solid #eeeef2",
        borderTop:    "3px solid #232231",
        animation:    "inspekt-spin 0.8s linear infinite",
        flexShrink:   0,
      }} />

      {/* Step text */}
      <p style={{
        margin:        0,
        fontSize:      12,
        color:         "#9ca3af",
        letterSpacing: "0.025em",
        textAlign:     "center",
        lineHeight:    1.5,
      }}>
        {isDeterminate ? `${step} ${Math.round(fill)}%` : step}
      </p>

      <style>{`
        @keyframes inspekt-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
